import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SERVER_URL } from './../config/contants';
import { API_TOKEN } from './../config/contants';
import { HttpHeaders } from '@angular/common/http'; 

@Injectable()
export class SugestoesProvider {

  constructor(public http: HttpClient) {

  }

  sendSugestao(mensagem) {
    return new Promise((resolve, reject) => {

      let body = new FormData();
      body.append('mensagem', mensagem);

      this.http.post(SERVER_URL + 'sugestoes/registrarSugestao', body, { headers: new HttpHeaders().set('X-API-KEY', API_TOKEN) })
        .subscribe(
          data => {
            resolve(data)
          },
          err => {
            reject(err)
          })
    })
  }

  sendContato(nome, email, mensagem) {
    return new Promise((resolve, reject) => {

      let body = new FormData();
      body.append('nome', nome);
      body.append('email', email);
      body.append('mensagem', mensagem);

      this.http.post(SERVER_URL + 'sugestoes/enviarContato', body, { headers: new HttpHeaders().set('X-API-KEY', API_TOKEN) })
        .subscribe(
          data => {
            resolve(data);
          },
          err => {
            reject(err);
          })
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/sugestoes.ts